module.exports = __webpack_public_path__ + "images/checklists/pointing-hand.9d6d5b454e050157108e.svg";